//movil 100%, 1/3 10% con clics
//navegador 2/3 1/3

// import { isInputElement } from 'react-router-dom/dist/dom';
import styled from 'styled-components';
const percentageSize = 1.3;

export const TabContainer = styled.div`
  height: 32px;
  width: 190px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
  cursor: ${({ enabled }) => (enabled ? 'pointer' : 'default')};
  opacity: ${({ enabled }) => (enabled ? '100%' : '40%')};
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  padding: 0px 5px;
  background-color: #666666;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 580px) {
    width: 120px;
    /* font-size: 10px; */
  }
`;

export const TabInfo = styled.div`
  display: flex;
  align-items: center;
  color: ${({ selected }) => (selected ? '#febf00' : 'white')};
`;
export const TabClose = styled.button`
  background-color: transparent;
  cursor: ${({ enabled }) => (enabled ? 'pointer' : 'default !important')};
  border: none;
`;
export const TabIcon = styled.div`
  margin-right: 5px;
`;
export const TabTitle = styled.div``;

export const InformacioPuntContainer = styled.div`
  width: 100vw;
  height: ${(props) => props.altura};
  max-height: 100%;
  background-color: #333c;
  z-index: 7;
  margin: 0;
  position: fixed;
  bottom: 0;
  display: ${({ open }) => (open ? 'block' : 'none')};
`;

export const InformacioPuntWrapper = styled.div`
  height: ${(props) => props.altura};
  /* display: grid;
  grid-template-rows: ${(props) => (props.displayInfoPuntBody ? '25px 0.5fr 30px' : '25px')}; */

  @media screen and (max-width: 464px) {
    /* grid-template-rows: ${(props) => (props.displayInfoPuntBody ? '25px 1fr' : '25px')}; */
  }
`;

export const InfoKeys = styled.div`
  font-weight: bold;
  margin-right: 5px;
`;

export const InformacioPuntBar = styled.nav`
  background-color: #333;
  box-shadow: 0 4px 7px -2px #252525;
  /* display: grid; */
  /* grid-template-rows: 1fr 1fr; */
  padding-left: 1em;
  padding-right: 1em;
  user-select: none;
  z-index: 3;
`;

export const InformacioPuntBarUpperRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 3px;
  height: 6px;
  align-items: center;
`;

export const InformacioPuntBarLowerRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BarTitleWrappper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-bottom: 5px;
  /* height: 15px; */
`;

export const BarDragIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: n-resize;
  align-items: flex-start;
  padding-top: 3px;
`;

export const BarSizeBtnsWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  flex-direction: row;
  height: 19px;
  @media screen and (max-width: 468) {
    height: 100%;
    padding-bottom: 5px;
  }
`;

export const CloseBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
`;

export const MaximizeBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  transform: rotate(180deg) scale(0.8);
  margin-left: 5px;
  margin-right: 5px;
`;

export const MinimizeBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  transform: scale(0.8);
  margin-left: 5px;
  margin-right: 5px;
`;

export const FullMinimizeBtnWrapper = styled.div`
  color: white;
`;

export const BarBtn = styled.button`
  background-color: transparent;
  border: 0px;
  margin: 0px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DataAlert = styled.div`
  display: flex;
  gap: 5px;
  text-decoration: underline;
  cursor: pointer;

  :hover {
    color: #febf00;
  }
`;

export const BarTitle = styled.span`
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 15 * percentageSize : 15)}px;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  }
`;

export const BarDragIcon = styled.div`
  height: 0.3em;
  width: 5em;
  border-radius: 0.5em;
  background-color: #ccc;
  display: inline-flex;
`;

export const InformacioPuntBodyWrapper = styled.div`
  display: ${({ displayInfoPuntBody }) => (displayInfoPuntBody ? 'flex' : 'none')};
  height: ${(props) => props.altura};
  padding-left: 5px;
  padding-right: 5px;

  //mobile
  @media screen and (max-width: 464px) {
    flex-direction: column;
    overflow-x: ${({ mobile }) => (mobile ? 'hidden' : 'scroll')};
    overflow-y: ${({ mobile }) => (mobile ? 'scroll' : 'hidden')};
  }

  ::-webkit-scrollbar {
    background-color: transparent;
    opacity: ${({ hovering }) => (hovering ? '1' : '0')};
    display: block;
    width: 7px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
    height: 50px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-bottom: 30px;
    margin-top: 15px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
    margin-left: 30px;
    margin-right: 30px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const InformacioGeneralContainer = styled.div`
  height: calc(100% - 25px);
  flex: 1 2 auto;
  overflow-y: auto;
  @media screen and (max-width: 468px) {
    overflow-y: unset;
    height: 100%;
  }

  ::-webkit-scrollbar {
    background-color: transparent;
    opacity: ${({ hovering }) => (hovering ? '1' : '0')};
    display: block;
    width: 7px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
    height: 20px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-bottom: 5px;
    margin-top: 5px;
    margin-left: 15px;
    margin-right: 30px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
    margin-left: 30px;
    margin-right: 30px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const InformacioGeneral = styled.article`
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  font-weight: 200;
  text-align: left;
  justify-content: center;
  padding: 1em;
  padding-bottom: 0px;

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  }
`;

export const LineaInformacio = styled.span`
  display: block;
`;

export const InformacioPuntFooter = styled.footer`
  display: ${(props) => (props.displayInfoPuntBody && !props.isMin ? (props.displayFooter ? 'grid' : 'none') : 'none')};
  position: absolute;
  bottom: 0px;
  padding: 0;
  padding-left: 1em;
  padding-bottom: 5px;
  box-shadow: 0 4px 7px -2px #4e4e4e;
  z-index: 2;

  @media screen and (max-width: 464px) {
    display: grid;
    position: relative;
    box-shadow: none;
    padding-left: 0.7em;
  }
`;

export const Carousel = styled.div`
  display: block;
  width: 100%;
  height: fit-content;
  padding-bottom: 3px;
  ::-webkit-scrollbar {
    background-color: transparent;
    opacity: ${({ hovering }) => (hovering ? '1' : '0')};
    display: block;
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
    height: 50px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-bottom: 30px;
    margin-top: 15px;
    margin-left: 15px;
    margin-right: 30px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
    margin-left: 30px;
    margin-right: 30px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  @media screen and (max-width: 768px) {
    height: 100%;
  }

  @media screen and (min-width: 465px) {
    overflow-x: ${({ mobile, nCards }) => (nCards === 0 ? 'hidden' : mobile ? 'hidden' : 'scroll')};
    overflow-y: ${({ mobile, nCards }) => (mobile ? 'scroll' : 'hidden')};
  }
`;

export const CarouselWrapper = styled.div`
  /* width: ${(props) => props.amplada + 'px'}; */
  display: flex;
  flex-direction: ${({ mobile }) => (mobile ? 'column' : 'row')};
  /* justify-content: space-between; */
  align-items: center;
  flex-wrap: nowrap;
  padding: 0.5em 1em 0 1em;
  margin: 0;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-top: 5px;
    margin-left: 5px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  @media screen and (max-width: 768px) {
    width: auto;
    display: block;
  }
  @media screen and (max-width: 464px) {
    width: ${({ innerWidth }) => innerWidth}px;
    display: flex;
    justify-content: center;
  }
`;

export const LeftButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

export const InfoButton = styled.button`
  border: 0px solid transparent;
  background-color: transparent;
  padding: 0;
  margin: 0;
`;

export const SvgIconWrapper = styled.div`
  transform: scale(0.8);
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
`;

export const ButtonIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  transform: scale(0.8);
  filter: brightness(0) invert(1);
`;

export const InfoPuntSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const MinSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  fill: 'white',
  viewBox: '0 0 64 64',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const PuntFora = styled.div`
  margin-top: 10px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const FavButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  margin-left: 2px;
`;
